import React from "react";

// context
import { useQueueContext } from "frontend/components/fort/mod/core/Layouts/QueueLayout/QueueContext.js";

// components
import {
    SidebarWrapper,
    Overview,
    Tags,
    License,
    History
} from "frontend/components/fort/mod/core/Sidebar/index.js";

//  "Visually Published", "Fully Published", or "Denied"
const overViewTitleMappings = [
    { needle: "DENIED_", displayText: "Denied" },
    { needle: "METADATA_MOD", displayText: "Visually Published" },
    { needle: "PUBLISHED_FULLY", displayText: "Fully Published" }
];

const getOverviewTitle = singleUploadSelected => {
    let overviewTitle = "Overview";
    if (singleUploadSelected) {
        const { status } = singleUploadSelected;
        overViewTitleMappings.forEach(mapping => {
            if (status.includes(mapping.needle)) {
                overviewTitle = `${overviewTitle} (${mapping.displayText})`;
            }
        });
    }

    return overviewTitle;
};

const PhotoModQueueSidebar = () => {
    const {
        state: { singleUploadSelected },
        selectedBatchObj
    } = useQueueContext();

    // TODO: Title
    const onSaveTitle = props => {
        // console.log({ onSaveTitle: props });

        // Server Side Error Handling
        return {
            errors: false,
            errorMessage: ""
        };
    };
    const onToggleApproveTitle = props => {
        // console.log({ onToggleApproveTitle: props });

        // Server Side Error Handling
        return {
            errors: false,
            errorMessage: ""
        };
    };

    // TODO: Description
    const onSaveDescription = props => {
        // console.log({ onSaveDescription: props });

        // Server Side Error Handling
        return {
            errors: false,
            errorMessage: ""
        };
    };
    const onToggleApproveDescription = props => {
        // console.log({ onToggleApproveDescription: props });

        // Server Side Error Handling
        return {
            errors: false,
            errorMessage: ""
        };
    };

    // TODO: Location
    // Note: I could not find "location" on the upload object
    // we may need to get this elsewhere?
    // or it could be called something else?
    const onLocationUpdate = ({ location }) => {
        // console.log({ location });
    };

    /*
        TODO: TAGS
        Note: I went off what I saw in UPL for tag shape, which did not have isApproved or hasWarning flags.
        I assumed BE would be adding these props to the Tag shape
        You can see the createTags() sample data I created here: frontend/components/fort/mod/photos/mockData/uploads.js
        tags: [],
     */
    const onTagAdd = ({ uploadId, newTagName }) => {
        // console.log({ uploadId, newTagName });
    };
    const onTagApprove = ({ uploadId, tag }) => {
        // console.log("Tag Approve Toggle", { uploadId, tag });
    };
    const onTagRemove = ({ uploadId, tag }) => {
        // console.log("Tag Remove", { uploadId, tag });
    };

    return (
        <SidebarWrapper>
            <Overview
                title={getOverviewTitle(singleUploadSelected)}
                onSaveTitle={onSaveTitle}
                onToggleApproveTitle={onToggleApproveTitle}
                onSaveDescription={onSaveDescription}
                onToggleApproveDescription={onToggleApproveDescription}
                onLocationUpdate={onLocationUpdate}
            />
            <Tags
                onTagAdd={onTagAdd}
                onTagApprove={onTagApprove}
                onTagRemove={onTagRemove}
                isEditable={selectedBatchObj?.isEditable?.tags}
            />
            <License />
            <History />
        </SidebarWrapper>
    );
};

export default PhotoModQueueSidebar;
